<template>
  <div>
    <transition name="wrapped-reveal">
      <slot name="revealed"></slot>
    </transition>
    <transition name="wrapped-animation">
      <slot></slot>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'ihu-transition-wrapper',
    data() {
      return {};
    },
  };
</script>

<style scoped lang="scss">
  .wrapped-reveal-enter-active {
    animation: entering-setup 1s;
  }

  .wrapped-reveal-leave-active {
    animation: entering-setup 0s reverse;
  }

  .wrapped-reveal-enter, .wrapped-reveal-leave-to {
    transform: scale(0); opacity: 0;
  }

  @keyframes entering-setup {
    0% {
      transform: scale(0);
      opacity: 0%;
    }
    20% {
      transform: scale(1);
      opacity: 100%;
    }
    100% {
      transform: scale(1);
      opacity: 100%;
    }
  }

  .wrapped-animation-enter-active {
    animation: fade-out 0s reverse;
  }

  .wrapped-animation-leave-active {
    animation: fade-out 1s;
  }

  .wrapped-animation-enter, .wrapped-animation-leave-to {
    transform: scale(1); opacity: 1;
  }

  @keyframes fade-out {
    0% {
      transform: scale(1);
      opacity: 100%;
    }
    20% {
      transform: scale(0);
      opacity: 0%;
    }
    100% {
      transform: scale(0);
      opacity: 0%;
    }
  }
</style>
